module.exports = __webpack_public_path__ + "static/media/settings-icon.acec16fe.svg";